export const FRECUENCY = ["Day of the Week", "Monthly", "Weekly", "Yearly", "One Time"];
export const DAYS_OF_THE_WEEK = "Day of the Week";
export const MONTHLY = "Monthly";
export const YEARLY = "Yearly";
export const minDate = new Date(new Date().getFullYear(), 0, 1);
export const maxDate = new Date(new Date().getFullYear(), 11, 31);
export const minDateMonth = new Date(new Date().getFullYear(), 9, 1);
export const maxDateMonth = new Date(new Date().getFullYear(), 9, 31);
export const currentDate = new Date(new Date().getFullYear(), 9, 15);
